<template>
  <div class="u-flex u-row-right login">
    <div class="form">
      <div class="u-flex tab">
        <div class="item" :class="{ 'active': curIndex === 0 }" @click="onTab(0)">密码登录</div>
        <div class="item" :class="{ 'active': curIndex === 1 }" @click="onTab(1)">验证码登录/注册</div>
      </div>
      <el-form ref="loginForm" class="login-form" :model="loginForm">
        <template v-if="curIndex === 0">
          <el-form-item label="账号" prop="account" :rules="{ required: true, message: '请输入账号', trigger: 'blur' }">
            <el-input v-model="loginForm.account" autocomplete placeholder="请输入账号" />
          </el-form-item>
          <el-form-item label="密码" prop="password" :rules="{ required: true, message: '请输入密码', trigger: 'blur' }">
            <el-input type="password" key="1" v-model="loginForm.password" autocomplete placeholder="请输入密码"
              :show-password="true" />
          </el-form-item>
        </template>
        <template v-if="curIndex === 1">
          <el-form-item label="手机号" prop="mobile" :rules="{
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          }">
            <el-input v-model="loginForm.mobile" autocomplete placeholder="请输入手机号" />
          </el-form-item>
          <el-form-item label="验证码" prop="captcha" :rules="{ required: true, message: '请输入验证码', trigger: 'blur' }">
            <el-input type="text" v-model="loginForm.captcha" autocomplete placeholder="请输入验证码">
              <template #suffix>
                <el-button class="captcha" @click="getCaptcha" type="text" :disabled="isCounting">{{ txt }}</el-button>
              </template>
            </el-input>
          </el-form-item>
        </template>
      </el-form>
      <div class="btn">
        <el-button class="login-btn" type="primary" @click="onLogin">立即登录</el-button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "Login",
  data() {
    return {
      curIndex: 0,
      loginForm: {
        account: "",
        password: "",
        // account: "13175016620",
        // password: "123456",
        captcha: "",
        mobile: "",
      },
      redirect: '',
      txt: '获取验证码',
      countdown: 0,
      isCounting: false,
      auth_code: '',
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    this.curIndex = this.$route.query.curIndex ? this.$route.query.curIndex : 0
    const auth_code = this.$route.query.auth_code ? this.$route.query.auth_code : '';
    const token = this.$route.query.token ? this.$route.query.token : '';
    this.auth_code = auth_code;
    if (token) {
      this.onAwsLogin(token)
    }
  },
  methods: {
    onTab(index) {
      this.curIndex = index
      this.$refs.loginForm.resetFields()
    },
    // 去注册
    onRegister() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          // console.log(valid)
        }
      })
    },
    /**
     * 获取验证码
     */
    getCaptcha() {
      if (this.loginForm.mobile == "") {
        return this.$message.error('请输入手机号')
      } else {
        this.$api.user.getCaptcha({ mobile: this.loginForm.mobile, event: 'mobilelogin' })
        this.countdown = 60
        this.isCounting = true
        const timer = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) {
            clearInterval(timer)
            this.isCounting = false
            this.txt = '获取验证码'
          } else {
            this.txt = `${this.countdown}秒后重新获取`
          }
        }, 1000)
      }
    },
    // 登录
    onLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          let form = this.loginForm
          form.auth_code = this.auth_code
          this.$store.dispatch('user/login', { type: this.curIndex, data: form }).then(() => {
            setTimeout(() => {
              this.$router.push({ path: this.redirect || '/' })
            }, 1000)
            this.$message.success('登录成功')
          })

        }
      })
    },
    onAwsLogin(token) {
      this.$store.commit('user/SET_TOKEN', token)
      setTimeout(() => {
        this.$router.push({ path: '/' })
      }, 1000)
      this.$message.success('登录成功')
    }
  }
}
</script>

<style scoped>
.login {

  padding: 0 200px;
  width: 100%;
  /* height: calc(100vh + 75px); */
  box-sizing: border-box;
  background: url(../assets/images/login.png);
  background-size: 100% 100%;
  overflow: hidden;
  display: flex;
  position: relative;
  background-position: 100%;
  height: 100vh;
}

.form {
  padding: 50px 50px 100px;
  width: 564px;
  height: 600px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #fff;
}

.tab .item {
  margin-right: 40px;
  height: 30px;
  font-size: 16px;
}

.tab .active {
  color: #2682ff;
  border-bottom: 2px solid #2682ff;
}

.form>>>.el-form-item {
  position: relative;
}

.form>>>.el-form-item:nth-of-type(2) {
  margin-bottom: 0;
}

.form>>>.el-form-item__label {
  margin-bottom: 10px;
  color: #000;
  font-size: 20px;
}

.form>>>.el-input__inner {
  padding: 0;
  color: #000;
  font-size: 18px;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #b3b3b3;
  background: unset
}

.form>>>.forget-password {
  color: #b3b3b3;
  font-size: 16px;
  text-decoration: underline;
}

.login-btn {
  margin-top: 40px;
  width: 100%;
  height: 50px;
  color: #fff;
  font-size: 16px;
  background: #207bff;
}

.login-btn:hover {
  background: #1022d6;
}

.login-form {
  margin-top: 60px;
}

.login-form>>>.el-form-item {
  position: relative;
}

.login-form>>>.el-form-item:nth-of-type(2) {
  margin-bottom: 0;
}

.login-form>>>.el-form-item__label {
  margin-bottom: 10px;
  color: #000;
  font-size: 16px;
}

.login-form>>>.el-form-item__label:before {
  display: none;
}

.login-form>>>.el-input__inner {
  padding: 0 12px;
  color: #000;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #b3b3b3;
  background: unset
}

.register-btn {
  margin: 20px 0 100px;
  width: 100%;
  color: #b3b3b3;
  text-align: center;
}

.captcha {
  padding: 0 10px;
}
</style>
